import { UPS_RETURN_METHODS, WHOLE_FOODS_RETURN_METHODS } from 'constants/returnLabelOptions';
import WholeFoodsLogo from 'images/zappos/WFM_logo.png';
import UpsLogo from 'images/zappos/ups-logo.svg';

import css from 'styles/components/account/returns/returnMethodBanner.scss';

const ShippingMethodBanner = ({ labelDelivery }) => {
  if (WHOLE_FOODS_RETURN_METHODS.includes(labelDelivery)) {
    return (
      <div className={css.banner}>
        <img src={WholeFoodsLogo} alt="WholeFoodsMarketLogo" />
      </div>
    );
  }

  if (UPS_RETURN_METHODS.includes(labelDelivery)) {
    return (
      <div className={css.banner}>
        <img src={UpsLogo} alt="UpsLogo" />
      </div>
    );
  }

  return null;
};

export default ShippingMethodBanner;
